import { call, put, select } from "redux-saga/effects";
import api, { makeOptions } from "@/services/api";
import toastify from "@/services/toastify";
import DeleteObservacaoActions from "@/store/ducks/empresas-observacoes/delete";

const getAuthData = state => state.auth.data;

export function* remove(action) {
  try {
    const { id, onSuccess } = action;
    const authData = yield select(getAuthData);
    const { data: response } = yield call(
      api.delete,
      `empresas-observacoes/${id}`,
      makeOptions(authData)
    );

    if (response.success) {
      toastify("Entrada no log removida com sucesso");
      if (onSuccess) onSuccess();
      yield put(DeleteObservacaoActions.deleteObservacaoSuccess());
    } else {
      toastify(response.message);
      yield put(DeleteObservacaoActions.deleteObservacaoFailure(response.message));
    }
  } catch (error) {
    toastify("Erro ao remover a entrada do log");
    yield put(DeleteObservacaoActions.deleteObservacaoFailure("Erro ao remover a entrada do log"));
  }
}
